module.exports = __webpack_public_path__ + "static/img/banner-ori.b22438e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-ori.jpg
// module id = NLd4
// module chunks = 1